var map = {
	"./claims/flexivel.svg": 9804,
	"./claims/flexivel_en.svg": 2542,
	"./claims/flexivel_es.svg": 5019,
	"./claims/flexivel_fr.svg": 7002,
	"./claims/forte.svg": 3363,
	"./claims/forte_en.svg": 3202,
	"./claims/forte_es.svg": 2950,
	"./claims/forte_fr.svg": 525,
	"./claims/imparavel.svg": 4218,
	"./claims/imparavel_en.svg": 6833,
	"./claims/imparavel_es.svg": 309,
	"./claims/imparavel_fr.svg": 3392,
	"./claims/logo_fastio_go.svg": 934,
	"./claims/melhor.svg": 6325,
	"./claims/melhor_en.svg": 5985,
	"./claims/melhor_es.svg": 70,
	"./claims/melhor_fr.svg": 9584,
	"./claims/resiliente.svg": 9749,
	"./claims/resiliente_en.svg": 5912,
	"./claims/resiliente_es.svg": 8956,
	"./claims/resiliente_fr.svg": 5793,
	"./claims/veloz.svg": 5026,
	"./claims/veloz_en.svg": 4387,
	"./claims/veloz_es.svg": 4215,
	"./claims/veloz_fr.svg": 6461,
	"./moments/bottle_body.png": 8428,
	"./moments/bottle_body.webp": 7597,
	"./moments/bottle_capsule.png": 5107,
	"./moments/bottle_capsule.webp": 4773,
	"./moments/bottle_fastio_go.png": 9015,
	"./moments/bottle_fastio_go.webp": 7259,
	"./moments/fastio_go_1.png": 4196,
	"./moments/fastio_go_1.webp": 6799,
	"./moments/fastio_go_2.png": 9960,
	"./moments/fastio_go_2.webp": 5137,
	"./moments/fastio_go_3.svg": 7209
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5098;